import React from "react";
import { Navigate } from "react-router-dom";
import { useWorkspace } from "./WorkspaceContext";

const SMBGuard = ({ children }) => {
  const { subscribeType } = useWorkspace();

  // Allow SMB Max (4) and SMB Max Managed (5) subscription types
  if (subscribeType && subscribeType != 4 && subscribeType != 5) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

export default SMBGuard;
